module.exports = __webpack_public_path__ + "static/img/PC-7.a7b2d04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgzgk/PC-7.png
// module id = UsGf
// module chunks = 0